import { requestApi } from '../util/network'

//达人主页
export const getvideouser =
    (svideoman,member_id,page) =>
        requestApi(
        	'/ExpertVideo/index',
        	'POST',{videoman_id: svideoman,member_id:member_id,page:page}
        )
        
//关注达人
export const getbeFans =
    (svideoman,member_id) =>
        requestApi(
        	'/ExpertVideo/beFans',
        	'POST',{videoman_id: svideoman,member_id:member_id}
        )
        
//取消关注
export const getcancelFocus =
    (svideoman,member_id) =>
        requestApi(
        	'/ExpertVideo/cancelFocus',
        	'POST',{videoman_id: svideoman,member_id:member_id}
        )

//视频详情
export const getVideoDetail =
    (video_id,member_id) =>
        requestApi(
        	'/ExpertVideo/detail',
        	'POST',{video_id: video_id,member_id:member_id},'member'
        )

//评论视频
export const getVideoMessage =
    (video_id,message,to_type,message_type,member_id,token) =>
        requestApi(
        	'/member_instant_message/add',
        	'POST',{to_id: video_id,message:message,to_type:to_type,message_type:message_type,member_id:member_id,key:token},'member'
        )
//点赞视频
export const getVideolike =
    (member_id,videoman_id,video_id) =>
        requestApi(
        	'/ExpertVideo/like',
        	'POST',{member_id: member_id,videoman_id:videoman_id,video_id:video_id},'member'
        )        

//视频总的列表页
export const getVideoList =
    (keyword,classid,type,page) =>requestApi(
        	'/ExpertVideo/list',
        	'POST',{keyword:keyword,class:classid,type:type,page:page}
        ) 
//视频播放页下一个ID
export const getVideoplayList =
    (video_id,page,type) =>requestApi(
        	'/ExpertVideo/nextVideo',
        	'POST',{video_id:video_id,page:page,type:type}
        )     
//标签列表     
export const getTagList =
    (page,member_id,token) =>requestApi(
        	'/Membervideoman/tag',
        	'POST',{member_id:member_id,page:page,key:token}
        ) 
//新增标签     
export const addTagList =
    (tag_id,svideotag_name,svideotag_desc,member_id,token) =>requestApi(
        	'/Membervideoman/handleTag',
        	'POST',{svideotag_id:tag_id,svideotag_name:svideotag_name,svideotag_desc,member_id:member_id,key:token}
        )   
//获取单个标签 信息    
export const endTagList =
    (tag_id,member_id,token) =>requestApi(
        	'/Membervideoman/getTag',
        	'POST',{tag_id:tag_id,member_id:member_id,key:token}
        )        
//删除标签     
export const deleteTagList =
    (tag_id,member_id,token) =>requestApi(
        	'/Membervideoman/delVideoTag',
        	'POST',{tag_id:tag_id,member_id:member_id,key:token}
       )
//判断是否是达人     
export const getisVideoMan =
    (member_id,token) =>requestApi(
        	'/Membervideoman/isVideoMan',
        	'POST',{member_id:member_id,key:token}
        )
//保存达人信息     
export const getsumVideoMan =
    (datas) =>requestApi(
        	'/Membervideoman/beVideoMan',
        	'POST',datas
        )   
//我的视频列表     
export const getmyvideo =
    (page,member_id,token) =>requestApi(
        	'/Membervideoman/video',
        	'POST',{member_id:member_id,page:page,key:token}
        )    
//删除视频     
export const getdeletevideo =
    (svideo_id,member_id,token) =>requestApi(
        	'/Membervideoman/delVideo',
        	'POST',{video_id:svideo_id,member_id:member_id,key:token}
        )   
//点击系统标签时，获取系统标签id 
export const getsystag =
    (tagname,member_id,token) =>requestApi(
        	'/Membervideoman/getSysTagId',
        	'POST',{sys_tag_name:tagname,member_id:member_id,key:token}
        ) 
//保存视频信息     
export const getVideoinfo =
    (datas) =>requestApi(
        	'/Membervideoman/handleVideo',
        	'POST',datas,
	        'member',
	        true
        )  
//获取单个视频信息    
export const endvideos =
    (video_id,member_id,token) =>requestApi(
        	'/Membervideoman/getVideo',
        	'POST',{video_id:video_id,member_id:member_id,key:token}
        )         